var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full justify-start items-center"},[_c('div',{staticClass:"flex items-center mr-2"},[_c('div',{staticClass:"material-icons",staticStyle:{"font-size":"16px"},style:({
        color:
          this.params.data.display_status === 4
            ? _vm.AISEA_COLOR.LIGHT_BLUE
            : null,
      })},[_vm._v("\n      "+_vm._s(_vm.statusIcon)+"\n    ")])]),_c('div',{staticClass:"aisea-text-16-400-black"},[_vm._v("\n    "+_vm._s(_vm.params.value)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }